export enum CardStatus {
  // Card creation states
  Creating = 'Creating',
  CreatingFailed = 'Creating Failed',

  // Transitional states (operations in progress)
  Activating = 'Activating',
  Blocking = 'Blocking',
  Closing = 'Closing',

  // Failed states
  ActivatingFailed = 'Activating Failed',
  BlockingFailed = 'Blocking Failed',
  ClosingFailed = 'Closing Failed',

  // Final states
  Active = 'Active',
  Blocked = 'Blocked',
  Closed = 'Closed',

  // Additional states (from existing code)
  Suspended = 'Suspended',
  Suspending = 'Suspending',
  Risk = 'Risk',
  Frozen = 'Frozen',
}
